(ns hai.home.desktop.views
  "Home dashboard (desktop) layout shells: page container and day columns."
  (:require
   [lambdaisland.ornament :as o]))

;; ---------------------------------------------------------------------------
;; Page container
;; ---------------------------------------------------------------------------

;; Full-bleed: the sage fills the whole main area (under the top bar, up to the
;; sidebar) and is the page's only background — no off-white card-in-a-card. One
;; padding layer holds the content off the edges, matching the side gutter other
;; pages use via layout/page.
(o/defstyled page-desktop :div
  :flex-grow
  {:margin "12px"
   :border-radius "16px"
   :padding "32px 36px 36px"
   :position "relative"
   :background "radial-gradient(circle at 20% 30%, rgba(184,196,166,0.2) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(184,196,166,0.15) 0%, transparent 50%), #E4E2D2"}
  [:at-media {:max-width "768px"}
   {:margin "8px" :padding "20px 16px 32px"}])

;; ---------------------------------------------------------------------------
;; Top row: time card + notes mini-app
;; ---------------------------------------------------------------------------

;; Clock hugs its content (auto track); the notes mini-app fills the rest up to
;; a cap, leaving whitespace on the right on wide screens. `justify-content`
;; start keeps the auto clock track from stretching to fill.
(o/defstyled top-row :div
  {:display "grid"
   :grid-template-columns "auto minmax(0, 480px)"
   :gap "40px"
   :align-items "start"
   :justify-content "start"
   :margin-bottom "28px"}
  [:at-media {:max-width "900px"}
   {:grid-template-columns "1fr" :gap "24px"}])

;; ---------------------------------------------------------------------------
;; Two-column layout
;; ---------------------------------------------------------------------------

(o/defstyled two-columns :div
  {:display "grid"
   :grid-template-columns "minmax(0, 1.2fr) minmax(0, 1fr)"
   :gap "20px"
   :align-items "start"
   :margin-bottom "28px"}
  [:at-media {:max-width "900px"}
   {:grid-template-columns "1fr" :gap "24px"}])
